import React from 'react';

import AdminAuthContainer from './AdminAuthContainer';
import AdminSettings from './AdminSettings';
import AdminSettingsContainer from './AdminSettingsContainer';
import AdminUsersContainer from './AdminUsersContainer';
import ClassesContainer from './components/Classes/ClassesContainer';
import ModalContainer from './ModalContainer';

const Portal = () => (
    <ModalContainer.Provider>
        <AdminAuthContainer.Provider>
            <AdminSettingsContainer.Provider>
                <AdminUsersContainer.Provider>
                    <ClassesContainer.Provider>
                        <AdminSettings />
                    </ClassesContainer.Provider>
                </AdminUsersContainer.Provider>
            </AdminSettingsContainer.Provider>
        </AdminAuthContainer.Provider>
    </ModalContainer.Provider>
);

export default Portal;
